import { createAction, PayloadAction } from "@reduxjs/toolkit";

export const OPEN_LISTITEMS: string = "OPEN_LISTITEMS";
export const CLOSE_LISTITEMS: string = "CLOSE_LISTITEMS";

export type IListItemsActionPayload = {
    title: string;
    header: string;
    items: string[];
};

export type IListItemsAction = PayloadAction<IListItemsActionPayload>;

export const openListItems =
    createAction<IListItemsActionPayload>(OPEN_LISTITEMS);

export const closeListItems = createAction(CLOSE_LISTITEMS);
